'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var mustache = require('mustache');
var clsx = require('clsx');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var SharingTruckIcon = require('@narvar/nth-bit-icon-sharing-truck');
var Alert = require('@narvar/nth-block-alert');
var TextLink = require('@narvar/nth-bit-text-link');
var layoutTree = require('@narvar/nth-kit-dynamic-layout-next/dist/src/layoutTree');
var SharingOptions = require('./components/SharingOptions.js');
var PrefetchData = require('./PrefetchData.js');
var GiftTracking_module = require('./GiftTracking.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var SharingTruckIcon__default = /*#__PURE__*/_interopDefaultLegacy(SharingTruckIcon);
var Alert__default = /*#__PURE__*/_interopDefaultLegacy(Alert);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const renderOptions = {
  escape: x => x
};
const GiftTracking = ({
  featureName,
  userAgentDevice
}) => {
  const [isVisible, setIsVisible] = React.useState(true);
  const [showSharingOptions, setShowSharingOptions] = React.useState(false);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    bodytextDefaultNone,
    linksNoneDefault: giftTrackingLinkStyle,
    linksNoneHover: giftTrackingLinkHoverStyle
  } = nthHookTheme.useTheme();
  const {
    state: {
      requestUrl,
      experienceHost,
      embedReferrerUrl
    }
  } = nthHookContextPage.usePageContext();
  const {
    giftTrackingBannerMessage,
    giftTrackingBannerLink,
    giftTrackingSharingMessageSubject,
    giftTrackingSharingMessageBody
  } = nthHookTranslations.useTranslations();
  const giftTrackingMessageStyle = bodytextDefaultNone && {
    ...bodytextDefaultNone,
    fontWeight: 'bold'
  };
  const isMobileDevice = userAgentDevice === layoutTree.Devices.MOBILE;

  // Values need to be memoized to prevent `logEvent` useEffect from
  // re-running on every render (eslint/react-hooks/exhaustive-deps)
  const baseLogInfo = React.useMemo(() => ({
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
    eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
    feature: featureName,
    pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING
  }), [featureName]);
  const handleDismissClicked = () => {
    setIsVisible(false);
    logEvent({
      ...baseLogInfo,
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.DISMISS,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.DISMISS,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK
    });
  };
  React.useEffect(() => {
    logEvent({
      ...baseLogInfo,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER
    });
  }, [logEvent, baseLogInfo]);

  // Appends cateogry=sharing more safely than manually appending
  // `&category=sharing` to `requestUrl`
  const giftTrackingURL = new URL(experienceHost === 'EMBED' && embedReferrerUrl ? embedReferrerUrl : requestUrl || window.location.href);
  giftTrackingURL.searchParams.set('category', 'sharing');
  const giftTrackingLink = giftTrackingURL.href;
  const giftTrackingSharingMessageBodyMustachedDesktop = mustache__default["default"].render(giftTrackingSharingMessageBody || '{{giftTrackingUrl}}', {
    giftTrackingUrl: encodeURIComponent(giftTrackingLink)
  }, undefined, renderOptions);
  const giftTrackingSharingMessageBodyMustachedMobile = mustache__default["default"].render(giftTrackingSharingMessageBody || '{{giftTrackingUrl}}', {
    giftTrackingUrl: giftTrackingLink
  }, undefined, renderOptions);
  const handleShowSharingOptions = () => {
    logEvent({
      clickCategory: isMobileDevice ? nthHookContextAnalytics.NarvarClickSubTypes.SHARE_LINK : nthHookContextAnalytics.NarvarClickSubTypes.SHOW_SHARING_OPTIONS,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.GIFT_TRACKING,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING
    });
    if (isMobileDevice && window.navigator.share) {
      window.navigator.share({
        title: giftTrackingSharingMessageSubject || '',
        text: giftTrackingSharingMessageBodyMustachedMobile || ''
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
    }
    if (!isMobileDevice) setShowSharingOptions(true);
  };
  const classes = clsx__default["default"]({
    [GiftTracking_module["default"].landscapeContainer]: true,
    [GiftTracking_module["default"].showSharingOptions]: showSharingOptions
  });
  return /*#__PURE__*/React__default["default"].createElement(Alert__default["default"], {
    featureName: featureName,
    show: isVisible,
    dismissible: true,
    dismissOnClick: handleDismissClicked,
    "data-test": "giftTrackingFeature"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes,
    "data-testid": "gift-tracking-view"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: GiftTracking_module["default"].sharingTruckContainer
  }, /*#__PURE__*/React__default["default"].createElement(SharingTruckIcon__default["default"], {
    featureName: featureName
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: GiftTracking_module["default"].bannerContainer
  }, giftTrackingBannerMessage && /*#__PURE__*/React__default["default"].createElement("div", {
    style: giftTrackingMessageStyle
  }, giftTrackingBannerMessage), giftTrackingBannerLink && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: giftTrackingLinkStyle,
      sHover: giftTrackingLinkHoverStyle
    },
    onClick: handleShowSharingOptions,
    "aria-expanded": showSharingOptions,
    "aria-controls": "sharing-options"
  }, giftTrackingBannerLink))), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "sharing-options",
    hidden: !showSharingOptions
  }, /*#__PURE__*/React__default["default"].createElement(SharingOptions["default"], {
    featureName: featureName,
    giftTrackingSharingMessageSubject: giftTrackingSharingMessageSubject || '',
    giftTrackingSharingMessageBody: isMobileDevice ? giftTrackingSharingMessageBodyMustachedMobile : giftTrackingSharingMessageBodyMustachedDesktop,
    giftTrackingLink: giftTrackingLink
  })));
};
const GiftTrackingWithData = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(GiftTracking, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'bodytextDefaultNone']
}), {
  translationKeys: ['giftTrackingBannerMessage', 'giftTrackingBannerLink', 'giftTrackingSharingMessageBody', 'giftTrackingSharingMessageSubject']
});
const GiftTrackingWithPretchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(GiftTrackingWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports.GiftTracking = GiftTracking;
exports["default"] = GiftTrackingWithPretchedData;
